import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Home from './core/Home';
import Menu from './core/Menu';
import NotFound from './core/NotFound';
import Video from './video/Video';
import VideosByChannel from './video/VideosByChannel';
import MyChannels from './video/MyChannels';

const MainRouter = () => {
  return (
    <div>
      <Menu />
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/manage/channels" component={MyChannels} />
        <Route path="/manage/videos" component={VideosByChannel} />
        <Route path="/manage/video/" component={Video} />
        <Route component={NotFound} />
      </Switch>
    </div>
  );
};

export default MainRouter;
